import { TmApiNotFoundError } from '@/core/error/transport/tmApiNotFoundError'

export class TmApiDealActivityNotFoundError extends TmApiNotFoundError {
  public name = 'TmApiDealActivityNotFoundError'
}
